import type { CollectionId } from "@anaconda/core/nft-collection/types"
import { usePathname } from "next/navigation"

import { getBlockchainFromAddress } from "@anaconda/core/blockchain/address"
import { getCollectionPathSegment } from "./collection/collection-path"

export enum DropPageType {
  OVERVIEW = "overview",
  ACTIVITY = "activity",
}

export const getDropHref = (dropId: CollectionId) => {
  const segment = getCollectionPathSegment(dropId)
  const blockchain = getBlockchainFromAddress(dropId)

  return `/${blockchain.toLowerCase()}/collections/${segment}/drops`
}

const HREF_FACTORY_BY_PAGE_TYPE: Record<
  DropPageType,
  (colletionId: CollectionId) => string
> = {
  [DropPageType.OVERVIEW]: (dropId) => `${getDropHref(dropId)}`,
  [DropPageType.ACTIVITY]: (dropId) => `${getDropHref(dropId)}/activity`,
}

export const useDropPageHref = (dropId: CollectionId, pageType: DropPageType) =>
  HREF_FACTORY_BY_PAGE_TYPE[pageType](dropId)

export const useDropActiveLinkChecker = (
  dropId: CollectionId,
  pageType: DropPageType,
) => {
  const urlPath = usePathname()
  const pathToCheck = useDropPageHref(dropId, pageType)

  return urlPath === pathToCheck
}

export const useCurrentDropPageType = (pathname: string | null = null) => {
  const currentPathname = usePathname()
  const targetPathname = pathname ?? currentPathname

  if (targetPathname.includes("/activity")) {
    return DropPageType.ACTIVITY
  }

  return DropPageType.OVERVIEW
}
